import React from 'react';
import { LogoProps } from './types';

function Pro({ width, height, color }: LogoProps) {
  return (
    <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          id="Vector"
          d="M10.9997 1.83331C5.93967 1.83331 1.83301 5.93998 1.83301 11C1.83301 16.06 5.93967 20.1666 10.9997 20.1666C16.0597 20.1666 20.1663 16.06 20.1663 11C20.1663 5.93998 16.0597 1.83331 10.9997 1.83331ZM15.583 11.9166H11.9163V15.5833H10.083V11.9166H6.41634V10.0833H10.083V6.41665H11.9163V10.0833H15.583V11.9166Z"
          fill={color}
        />
      </g>
    </svg>
  );
}

export default Pro;
